// extracted by mini-css-extract-plugin
export default {"main":"minecraftServersPage_main__QELg9"};